import './IA.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import Picture from '@/common/components/atoms/Picture/Picture';
import LinkLikeButton from '@/common/components/blocks/LinkLikeButton/LinkLikeButton';
import { ROUTE_CARTS } from '@/common/constants';
import { useDefaultCartContext } from '@/common/contexts/DefaultCartContext';
import getImageBySize from '@/common/helpers/getImageBySize';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';
import { ReactComponent as CheckIcon } from '@/materiaux/assets/icons/check.svg';

import { IADefaultProps, IAPropTypes } from './IA.proptypes';

const IA = ({ children, closeModal, item }) => {
  const { t } = useTranslation();
  const { defaultCart } = useDefaultCartContext();

  return (
    <div className="modal-ia__content" data-qa-id="modal-ia">
      <div className="modal-ia__product" data-qa-id="modal-ia-product">
        <div className="added">
          <div className="added__icon">
            <CheckIcon className="icon" />
          </div>
          <Picture
            alt={item?.product?.image?.alt || item?.product?.name}
            className="added__image"
            src={
              item?.product?.image?.url
                ? getImageBySize(
                    item?.product?.image?.url,
                    PRODUCTS_TYPES_FORMATS.LIST,
                  )
                : ''
            }
            type="static"
          />
          <div className="added__title" data-qa-id="added-title">
            {t('ebat:entities:common.modal.ia.added')}
            <p className="added__cart" data-qa-id="added-cart">
              {defaultCart.name}
            </p>
          </div>
          <p className="added__brand" data-qa-id="added-brand">
            {item?.product?.brand.name}
          </p>
          <p className="added__name" data-qa-id="added-name">
            {item?.product?.name}
          </p>
        </div>
        <Button
          buttonSize="large"
          className="modal-ia__action"
          context="continue-shopping"
          onClick={closeModal}
          variant="secondary-light"
        >
          {t('ebat:entities:common.modal.ia.actions.continue_shopping')}
        </Button>
        <LinkLikeButton
          buttonSize="large"
          className="modal-ia__action"
          context="see-cart"
          onClick={closeModal}
          url={`${ROUTE_CARTS}/${defaultCart?.id}`}
          variant="primary"
        >
          {t('ebat:entities:common.modal.ia.actions.see_cart')}
        </LinkLikeButton>
      </div>
      <div className="modal-ia__suggestions" data-qa-id="modal-ia-products">
        {children}
      </div>
    </div>
  );
};

IA.defaultProps = {
  ...IADefaultProps,
};

IA.propTypes = {
  ...IAPropTypes,
};

export default IA;
